import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Switch } from 'react-router-dom'
import './index.css';
import registerServiceWorker from './registerServiceWorker';

// apollo 2
import { ApolloProvider } from 'react-apollo';
import { ApolloClient } from 'apollo-client';
import { HttpLink } from 'apollo-link-http';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { split } from 'apollo-link';
import { setContext } from 'apollo-link-context';
import { WebSocketLink } from 'apollo-link-ws';
import { getMainDefinition } from 'apollo-utilities';

import {Route} from "react-router";
import App from "./App";
import Home from "./Home";
import DiscoveryDetail from "./DiscoveryDetail";

const API_URL = 
(document.location.hostname==="discovery.brikl.io") ? 
"https://api.brikl.io" 
: 
(document.location.hostname==="staging.discovery.brikl.io") ?
"https://staging.api.brikl.io" 
:
(document.location.hostname==="staging.discovery.ap-south-1.brikl.io") ?
"https://staging.api.ap-south-1.brikl.io" 
:
"http://localhost:3000";

const WS_URL = 
(document.location.hostname === "app.brikl.io") ? 
"wss://gql-subscription.brikl.io/subscriptions" 
: 
(document.location.hostname === "staging.app.brikl.io") ? 
`wss://staging.gql-subscription.brikl.io./subscriptions`
: 
"ws://localhost:7171/subscriptions";

// Apollo 2
// Create an http link:
const httpLink = new HttpLink({
  uri: API_URL + '/data/'
});
const token = localStorage.getItem('id_token');

const authLink = setContext((_, { headers }) => {
  // get the authentication token from local storage if it exists  
  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : null,
    }
  }
});

// Create a WebSocket link:
const wsLink = new WebSocketLink({  
  uri: WS_URL,
  options: {
    reconnect: true,
    connectionParams() {
      // get the authentication token from local storage if it exists
      return { jwt: token };
    },
    lazy: true,
  }
});

// using the ability to split links, you can send data to each link
// depending on what kind of operation is being sent
const link = split(
  // split based on operation type
  ({ query }) => {
    const { kind, operation } = getMainDefinition(query);
    return kind === 'OperationDefinition' && operation === 'subscription';
  },
  wsLink,
  httpLink,
);




export const client = new ApolloClient({
  // By default, this client will send queries to the
  //  `/graphql` endpoint on the same host
  link: authLink.concat(link),
  cache: new InMemoryCache(),
  // dataIdFromObject: o => o.id,
  dataIdFromObject: object => object.id,
});

ReactDOM.render(
<ApolloProvider client={client}>
  <BrowserRouter>
      <App>
        <Switch>
          <Route path="/" exact access="allUser" component={Home}/>									
          <Route exact path="/:id" access="allUser" component={DiscoveryDetail}/>
        </Switch>
      </App>
  </BrowserRouter>    
</ApolloProvider>
, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js